
import React, { useEffect } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Grid, Container } from "@mui/material";
import "../../style/sostenibilidad/inclusion.css";


/* imagenes */
import portada from "../../img/sostenibilidad/inclusion/inclusion-diversidad.png";
import imagen from "../../img/sostenibilidad/inclusion/genero.png";
import imagen1 from "../../img/sostenibilidad/inclusion/multiculturalidad.png";
import imagen2 from "../../img/sostenibilidad/inclusion/generacional.png";
import imagen3 from "../../img/sostenibilidad/inclusion/discapacidad.png";
import imagen4 from "../../img/sostenibilidad/inclusion/diversidad.png";
import imagen5 from "../../img/sostenibilidad/inclusion/justo.png";
import imagen6 from "../../img/sostenibilidad/inclusion/interes.png";
import imagen7 from "../../img/sostenibilidad/inclusion/empleo-local.png";
import descarga from "../../img/home/acreditacion/descarga.png";
import pdf1 from "../../img/pdf/POLITICA-DIV-INC-AXNN.pdf";

export default function Sostenibilidadinclusion() {
  useEffect(() => {
    // Inicializa AOS con opciones de configuración si es necesario
    AOS.init({
      duration: 1000, // Duración de las animaciones en milisegundos
      once: true, // Solo realiza las animaciones una vez
    });
  }, []);
  return (
    <Container maxWidth="md" sx={{marginTop:'50px', marginBottom:'100px', display:'flex', alignItems:'center', justifyContent:'center', flexDirection:'column'}}>
      <section className="portada-inclusion"  data-aos="fade-down">
        <img src={portada} alt="axinntus servicios, industriales, seguridad, mantenimiento, operación, equipos"  title='axinntus servicios, industriales, seguridad, mantenimiento, operación, equipos' />
        <div className="info-inclusion">
          <span>
            {" "}
            En Axinntus promovemos una <strong>
              cultura basada en el respeto y la equidad
            </strong> entendiendo que la diversidad impulsa la innovación, fortalece los
equipos y contribuye al desarrollo sostenible de la organización y de la sociedad. La equidad es el principio que orienta nuestras acciones para
garantizar que cada persona acceda a las mismas oportunidades, considerando sus contextos particulares.

            {" "}
          </span>
         
          <span style={{marginTop:'20px'}}>
            {" "}
            <strong>
              Rechazamos toda práctica discriminatoria
            </strong> discriminatoria basada en género, identidad o expresión de género, orientación sexual, etnia, nacionalidad, edad,
cultura, religión, estado civil, situación socioeconómica, idioma, discapacidad, condición de salud, apariencia, afiliación política, lugar de origen o
cualquier otra condición personal. En todos estos ámbitos, aplicamos un enfoque de equidad que permita corregir desigualdades históricas y
estructurales.

            {" "}
          </span>
        </div>
      </section>
      <section className="inclusion" data-aos="zoom-in">
        <div className="info-inclusion">
          <h1 className="titulo">Focos prioritarios</h1>
          <Grid container spacing={4} sx={{display:"flex", alignItems:'center', justifyContent:'center'}} >
            
            <Grid item xs={12} sm={6}  md={2.4}>
               <Grid container>
                 <Grid item xs={12}>
<div className="contiene-difucion-inclusion">
                <img src={imagen} alt="axinntus servicios, industriales, seguridad, mantenimiento, operación, equipos"  title='axinntus servicios, industriales, seguridad, mantenimiento, operación, equipos'/>
             
              </div>
                 </Grid>
                   <Grid item xs={12}>
                    <div className="texto-inclusion-icono">
                        <h1>Equidad de género</h1>
                    </div>
                   </Grid>
               </Grid>
              
            </Grid>
             <Grid item xs={12} sm={6}  md={2.4}>
               <Grid container>
                 <Grid item xs={12}>
<div className="contiene-difucion-inclusion">
                <img src={imagen1} alt="axinntus servicios, industriales, seguridad, mantenimiento, operación, equipos"  title='axinntus servicios, industriales, seguridad, mantenimiento, operación, equipos'/>
             
              </div>
                 </Grid>
                   <Grid item xs={12}>
                    <div className="texto-inclusion-icono">
                        <h1>Multiculturalidad</h1>
                    </div>
                   </Grid>
               </Grid>
              
            </Grid>

             <Grid item xs={12} sm={6}  md={2.4}>
               <Grid container>
                 <Grid item xs={12}>
<div className="contiene-difucion-inclusion">
                <img src={imagen7} alt="axinntus servicios, industriales, seguridad, mantenimiento, operación, equipos"  title='axinntus servicios, industriales, seguridad, mantenimiento, operación, equipos'/>
             
              </div>
                 </Grid>
                   <Grid item xs={12}>
                    <div className="texto-inclusion-icono">
                        <h1>Empleo Local</h1>
                    </div>
                   </Grid>
               </Grid>
              
            </Grid>
           

             <Grid item xs={12} sm={6}  md={2.4}>
               <Grid container>
                 <Grid item xs={12}>
<div className="contiene-difucion-inclusion">
                <img src={imagen3} alt="axinntus servicios, industriales, seguridad, mantenimiento, operación, equipos"  title='axinntus servicios, industriales, seguridad, mantenimiento, operación, equipos'/>
             
              </div>
                 </Grid>
                   <Grid item xs={12}>
                    <div className="texto-inclusion-icono">
                        <h1>Personas en situación </h1>
                        <h1> de discapacidad</h1>
                    </div>
                   </Grid>
               </Grid>
              
            </Grid>
          
            
             <Grid item xs={12} sm={6}  md={2.4}>
               <Grid container>
                 <Grid item xs={12}>
<div className="contiene-difucion-inclusion">
                <img src={imagen2} alt="axinntus servicios, industriales, seguridad, mantenimiento, operación, equipos"  title='axinntus servicios, industriales, seguridad, mantenimiento, operación, equipos'/>
             
              </div>
                 </Grid>
                   <Grid item xs={12}>
                    <div className="texto-inclusion-icono">
                        <h1>Diversidad generacional</h1>
                    </div>
                   </Grid>
               </Grid>
              
            </Grid>
            
           
           
              
          </Grid>
        </div>

       

        <div className="boton-descarga">
       
          <a href={pdf1} download target="_blank" rel="noopener noreferrer" style={{textDecoration: 'none', color: 'inherit'}}>
              <button>
                {" "}
                <div className="icono-descargar">
                  
                  <img src={descarga} alt="axinntus servicios, industriales, seguridad, mantenimiento, operación, equipos"  title='axinntus servicios, industriales, seguridad, mantenimiento, operación, equipos' />{" "}
                </div>{" "}
                Descargar Política de Inclusión y Diversidad
              </button>
            </a>
          
        </div>
      </section>
    </Container>
  );
}
